/** エラー情報から文字列を作成する */
export function errorToStr(error: any): string {
  let str = "";
  if (error.response) {
    str = `${error.response.status}:${error.response.statusText}\n${error.response.data.error_msg}`;
  } else {
    str = `エラーが発生しました。${String(error)}`;
  }
  return str;
}
